import { render, staticRenderFns } from "./exam-add.vue?vue&type=template&id=85377fc4&"
import script from "./exam-add.vue?vue&type=script&lang=js&"
export * from "./exam-add.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports